import { SubscriptionDto } from "./subscription.types"

export enum CompanySetupStatus {
  PENDING_PAYMENT = "PENDING_PAYMENT",
  INITIAL_SETUP = "INITIAL_SETUP",
  COMPLETE = "COMPLETE",
}

export enum CompanyTier {
  STANDARD = "STANDARD",
  SOS_FREE = "SOS_FREE",
  // Aged-out non-paying company: full paywall (StalePaywall replaces Main).
  STALE = "STALE",
}

export type CompanyMetadataDto = {
  airByte?: {
    workspaceId: string
    destinationId: string
  }
  fivetranGroupId?: string
  s3Folder?: string
  stripeCustomerId?: string
  sosReportReadyNotifiedAt?: string
  keywords?: {
    google?: {
      searchAlias?: string
      brands: string[]
      competitors: string[]
      categories: string[]
      hash: string | null
      regions: string[]
    }
    instagram?: {
      competitors: string[]
      hash: string
    }
  }
  mentions?: {
    brandKeywords?: string[]
    facebookUsernames?: string[]
    igUsernames?: string[]
    tiktokUsernames?: string[]
    webTerms?: {
      primaryTerm: string
      supportTerms?: string[]
    }[]
  }
  industry?: string
  timezone?: string
  currency?: string
  isPipelineEnabled?: boolean
  freeAccessEndsAt?: string | null
  hasCustomPlan?: boolean
  isBillingEnabled?: boolean
  skippedServices?: string[]
  revenueSource?: string
  skipOnboardingFlow?: boolean
  homePage?: {
    setupGuideSection?: {
      hiddenCards?: string[]
    }
    learningZoneSection?: {
      isHidden?: boolean
    }
  }
  settings?: {
    flags?: {
      ga_multi_property?: boolean
    }
  }
  /**
   * Country breakout (USA / Canada) settings. pipeline-dbt reads these straight
   * off Company.metadata (`$.regional.*`), so the keys ARE the dbt contract:
   * snake_case, flat. Mirrors CompanyMetadataJson in apps/api.
   */
  regional?: {
    enabled?: boolean
    /** Case-insensitive substring that marks a campaign name as USA. */
    usa_slug?: string
    /** Case-insensitive substring that marks a campaign name as Canada. */
    canada_slug?: string
    /** GA4 property id (bare numeric) → country the whole property reports as. */
    ga_property_countries?: Record<string, "USA" | "Canada">
  }
  model_props?: {
    ecom: {
      dep_var: string
      dep_var_scaler: string
    }
  }
  audiences?: {
    engaged?: string[]
    existingCustomer?: string[]
  }
}

export type CompanyDto = {
  id: string
  name: string
  metadata: CompanyMetadataDto
  domain?: string
  setupStatus: CompanySetupStatus
  tier?: CompanyTier
  isAgencyClient?: boolean
  createdAt: string
  updatedAt: string
  subscription: SubscriptionDto | null
}

export type CompanySubscriptionMetadataDto = {
  daysOfTrial?: number
  stripeCustomerId?: string
  subscriptionId?: string
  daysUntilDue?: number
  trialEnd?: Date
  customerId?: string
  priceId?: string
}
